import { rest } from 'msw';
import { patient, reimbursementRequest } from './fixtures/patient';

export const patientHandlers = [
  rest.get('*/re/v1/patient/:id',
    (req, res, ctx) => res(
      ctx.status(200),
      ctx.json(patient),
    )),
  rest.put('*/re/v1/patient/:id',
    (req, res, ctx) => res(
      ctx.status(200),
      ctx.json(patient),
    )),
  rest.get('*/re/v1/patient/:id/reimbursement-request/',
    (req, res, ctx) => res(
      ctx.status(200),
      ctx.json(reimbursementRequest),
    )),
];
